import { CodeKindReference }                 from '@/models/services/code/CodeKindModel';
import DeliverableTransferStatusHistoryModel from '@/models/services/shop/DeliverableTransferStatusHistoryModel';

export function isTicketTransferable(params: {
	codeKindReference: CodeKindReference;
	ticketHasBeenTransfered: boolean;
	isBackedByDeliverable: boolean; // Un transfert s'opère toujours sur un deliverable
	isFromShop: boolean;
	transferStatusHistory?: DeliverableTransferStatusHistoryModel;
}) {
	const {
		codeKindReference,
		ticketHasBeenTransfered,
		isBackedByDeliverable,
		isFromShop,
		transferStatusHistory,
	} = params;

	const cond_ticketIsExchangeOrTicket =
		codeKindReference === 'exchange' || codeKindReference === 'ticket';

	const cond_ticketNotTransferred =
		!ticketHasBeenTransfered;

	const cond_isBackedByDeliverable = isBackedByDeliverable;

	const cond_isFromShop = isFromShop;

	const firstStatus =
		transferStatusHistory?.deliverableTransferStatus?.reference;

	const cond_statusAllowsTransfer =
		transferStatusHistory === undefined
		||
		(
			transferStatusHistory instanceof DeliverableTransferStatusHistoryModel
			&& (firstStatus === 'refused' || firstStatus === 'canceled')
		);

	return (
		cond_ticketIsExchangeOrTicket
		&& cond_ticketNotTransferred
		&& cond_isBackedByDeliverable
		&& cond_isFromShop
		&& cond_statusAllowsTransfer
	);
}
